import { Interest } from '@io/domain/interest';
import { Filters, LoadingState } from '@io/domain';
import { MortgageInterestRateService } from '@io/services/mortgage-interest-rate/mortgage-interest-rate.service';
import { AppointmentComponent } from '@io/application/appointment/appointment.component';
import { InterestsComponent } from '@io/application/interests/interests.component';
import { FiltersComponent } from '@io/application/filters/filters.component';

import { Component, inject, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { AsyncPipe } from '@angular/common';

import { ApContentPipe, ApContentService } from '@ap/content';
import { ApError, ApErrorComponent, ApErrorService } from '@ap/error';
import { ApSpinnerComponent } from '@ap/spinner';
import { ApPanelComponent } from '@ap/panel';

@Component({
    selector: 'overview',
    standalone: true,
    imports: [
        AppointmentComponent,
        ApSpinnerComponent,
        ApErrorComponent,
        AsyncPipe,
        ApContentPipe,
        ApPanelComponent,
        FiltersComponent,
        InterestsComponent
    ],
    templateUrl: './overview.component.html'
})
export class OverviewComponent implements OnInit {
    private readonly contentService = inject(ApContentService);
    private readonly errorService = inject(ApErrorService);
    private readonly interestRateService = inject(MortgageInterestRateService);

    protected readonly loadingState = LoadingState;

    loading: LoadingState = LoadingState.IDLE;
    interests: Interest[];
    apError$: Observable<ApError>;

    ngOnInit(): void {
        this.apError$ = this.errorService.error$();
    }

    filterChange(filters: Filters): void {
        this.loading = LoadingState.LOADING;
        this.interestRateService.getInterestRateOverview(filters).subscribe({
            next: (interests: Interest[]) => {
                this.interests = interests;
                this.errorService.publish(null);
                this.loading = LoadingState.COMPLETED;
            },
            error: (error: ApError) => {
                error.message = this.contentService.get('interest-overview.error.message');
                error.showReloadOption = true;
                this.errorService.publish(error);
                this.loading = LoadingState.FAILED;
            },
            complete: () => (this.loading = LoadingState.IDLE)
        });
    }
}
